import { useState } from 'react'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { FormWrapper } from "./styled"
import { authSelector, tourDetailSelector } from 'redux/selector';
import { commentActions } from "redux/slice/commentSlice"
import { useLocation, useNavigate } from 'react-router-dom';

function FormInputComment({ callBack }) {
    const [inputComment, setInputComment] = useState('')
    const [errorInput, setErrorInput] = useState('')
    const tourDetailState = useSelector(tourDetailSelector)
    const tourId = tourDetailState.tourData.tour_id
    const dispatch = useDispatch()
    const authState = useSelector(authSelector)
    const location = useLocation();
    const pathname = location.pathname;
    const navigate = useNavigate()

    const handleSentComment = () => {
        if (!authState.isLoggedIn) return navigate("/login", { state: { pathname } });

        if (inputComment.trim().length >= 12) {
            setErrorInput("")
            const data = {
                tour_id: tourId,
                content: inputComment
            }
            dispatch(commentActions.create({ data, callBack, setInputComment }))

        } else {
            setErrorInput("Bình luận có độ dài tối thiểu 12 ký tự")
        }
    }
    return (
        <FormWrapper>
            <div className='comment_ask_top_form'>
                <textarea placeholder='Nhập bình luận của bạn...' onChange={e => setInputComment(e.target.value)} value={inputComment}></textarea>
                <div>
                    <p>{errorInput}</p>
                    <button onClick={handleSentComment}>Gửi bình luận</button>
                </div>
            </div>
        </FormWrapper>
    )
}
export default FormInputComment